class SupplierController extends AbstractEntityEditController
	@register()
	@inject 'Guid',
		'SuppliersRepository'
		'supplier'
		'purchaseOrders'
		'PURCHASE_ORDER'

	initialize: ->
		@mainCrud.entityType = 'general.supplier'
		@mainCrud.entityTitle = 'general.new.supplier'

		if angular.isDefined @supplier.id
			@mainCrud.entityTitle = @supplier.name
			@mainCrud.isNewEntity = false

		@mainCrud.tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'general.purchase_orders'
				selector: '#tab-purchase-orders'
				inactive: _.isEmpty @purchaseOrders
				disabled: angular.isUndefined @supplier.id
			}
		]

	save: ->
		supplier = angular.copy @supplier

		@SuppliersRepository
			.save supplier, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave response
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @SuppliersRepository, @supplier

	generateId: ->
		@supplier.id = @Guid.generate()
